"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarFlyoutButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _useHovered = require("../../../../util/useHovered");
var _flyout = require("../../../flyout");
var _menu = require("../../../menu");
var _useComposedBlur = require("../../hooks/useComposedBlur");
var _useFocusElement = require("../../hooks/useFocusElement");
var _ToolbarFlyoutButtonContentBefore = require("../../styled/ToolbarFlyoutButtonContentBefore");
var _ToolbarFlyoutButtonStyled = require("../../styled/ToolbarFlyoutButtonStyled");
var _toolbarTheme = require("../../styled/toolbarTheme");
var _ToolbarButtonBase = require("../ToolbarButtonBase");
const ToolbarFlyoutButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    isChecked = false,
    showHovered = false,
    flyoutId,
    onBlur,
    onFocus,
    onFlyoutOpenStateChange,
    flyoutRef: providedFlyoutRef,
    flyoutZIndex,
    flyoutPlacement = "bottom",
    onMouseEnter: providedOnMouseEnter,
    onMouseLeave: providedOnMouseLeave,
    ...rest
  } = _ref;
  const {
    isHovered,
    onMouseEnter,
    onMouseLeave
  } = (0, _useHovered.useHovered)({
    onMouseEnter: providedOnMouseEnter,
    onMouseLeave: providedOnMouseLeave
  });
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    onCloseRequested,
    onOpenRequested,
    isOpen
  } = (0, _menu.useMenuOpenState)();
  const localFlyoutRef = (0, _react.useRef)(null);
  const buttonRef = (0, _react.useRef)(null);
  const focusProps = (0, _useFocusElement.useFocusElement)({
    targetRef: ref ? ref : buttonRef,
    onFocus,
    onBlur,
    onKeyDown: rest.onKeyDown
  });
  const forkFlyoutRef = (0, _lodestarUtils.useForkRef)(localFlyoutRef, providedFlyoutRef || null);

  // wrap this in useCallback
  const onClosingFlyout = (0, _react.useCallback)(() => {
    onCloseRequested();
    onFlyoutOpenStateChange?.(false);
  }, [onCloseRequested, onFlyoutOpenStateChange]);
  const onOpeningFlyout = (0, _react.useCallback)(() => {
    onOpenRequested();
    onFlyoutOpenStateChange?.(true);
  }, [onFlyoutOpenStateChange, onOpenRequested]);
  const {
    flyoutProps,
    targetProps: targetFlyoutProps
  } = (0, _flyout.useFlyout)({
    isOpen,
    onCloseRequested: () => {
      onClosingFlyout();
      buttonRef.current?.focus();
    },
    closeOnEscape: true,
    targetRef: focusProps.ref,
    placement: flyoutPlacement,
    offset: {
      distance: 4
    },
    id: flyoutId,
    portalProps: {
      zIndex: flyoutZIndex
    }
  });
  const closeDropDown = (0, _react.useCallback)(() => {
    onCloseRequested();
    onFlyoutOpenStateChange?.(false);
    buttonRef.current?.focus();
  }, [onCloseRequested, onFlyoutOpenStateChange]);
  const childElement = (0, _react.useMemo)(() => {
    return children({
      closeDropDown
    });
  }, [children, closeDropDown]);
  const {
    onBlur: wrapperOnBlur,
    onFocus: wrapperOnFocus,
    onMouseDown: wrapperOnMouseDown,
    onMouseUp: wrapperOnMouseUp
  } = (0, _useComposedBlur.useComposedBlur)({});
  return /*#__PURE__*/_react.default.createElement(_flyout.ClickAwayListener, {
    onClickAway: onClosingFlyout
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement(_ToolbarFlyoutButtonStyled.ToolbarFlyoutButtonStyled, {
    onFocus: wrapperOnFocus,
    onBlur: wrapperOnBlur,
    onMouseDown: wrapperOnMouseDown,
    onMouseUp: wrapperOnMouseUp
  }, rest.contentBefore && /*#__PURE__*/_react.default.createElement(_ToolbarFlyoutButtonContentBefore.ToolbarFlyoutButtonContentBefore, null, rest.contentBefore) || null, /*#__PURE__*/_react.default.createElement(_ToolbarButtonBase.ToolbarButtonBase, (0, _extends2.default)({}, rest, {
    isChecked: isChecked,
    isOpen: isOpen,
    isHovered: showHovered || isHovered,
    iconAfter: (0, _toolbarTheme.getToolbarDropdownArrowIconTheme)(themeMode),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, focusProps, {
    onClick: () => {
      if (!isOpen) {
        onOpeningFlyout();
      } else {
        onClosingFlyout();
      }
    },
    onKeyDown: evt => {
      focusProps.onKeyDown?.(evt);
      switch (evt.key) {
        case "ArrowDown":
        case "ArrowUp":
          onOpeningFlyout();
          break;
        case "ArrowLeft":
        case "ArrowRight":
        case "Tab":
          onClosingFlyout();
          break;
        default:
          break;
      }
    }
  }, targetFlyoutProps))), /*#__PURE__*/_react.default.createElement(_flyout.Flyout, (0, _extends2.default)({}, flyoutProps, {
    ref: forkFlyoutRef,
    targetElement: buttonRef
  }), isOpen && childElement)));
});
exports.ToolbarFlyoutButton = ToolbarFlyoutButton;
ToolbarFlyoutButton.displayName = "ToolbarFlyoutButton";
//# sourceMappingURL=ToolbarFlyoutButton.js.map